import loader from '../moduleLoader.js';
import shave from 'shave';

class Teasers {
    constructor(container) {
        this.container = container;
        this.handleResize = this.handleResize.bind(this);
    }
    init() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }
    handleResize() {
        const teasers = this.container.querySelectorAll('.teaser')
        Array.from(teasers).forEach(teaser => {
            const headingHeight = teaser.querySelector('.teaser__heading').offsetHeight;
           // const buttonHeight = teaser.querySelector('.btn').offsetHeight;
            const containerHeight = teaser.offsetHeight;
            const teaserText = teaser.querySelector('.teaser__text');
            const teaserMeta = teaser.querySelector('.teaser__meta');
            var height = containerHeight - headingHeight - 60;
            if(teaserMeta) {
                height = height - teaserMeta.offsetHeight;
            }
           /* if(buttonHeight < 50) {
                height = height - buttonHeight;
            }*/
            /*shave(teaserText, height-50);*/
        });
    }
}

loader.add('Teasers', Teasers);

export default Teasers;